import { Wind, Layers, BadgeCheck, Leaf, Sofa, Building2, Bath, PawPrint, ShieldCheck, Check } from 'lucide-react';

const FEATURES = [
  { I: Wind, t: 'Tecnologia "Odor-Stop"', d: 'Grazie a un principio attivo specifico, neutralizza e abbatte completamente gli odori più difficili (fumo, cucina, toilette, fino all\'odore di bruciato).' },
  { I: Layers, t: 'Versatilità Totale', d: 'Progettato per ambienti, tessuti delicati (tende, tappeti, moquette), armadi, scarpiere e aree critiche (lettiere, cucce, cassonetti).' },
  { I: BadgeCheck, t: 'Igiene Certificata', d: 'Perfetto per il completamento delle pulizie in ambito professionale e domestico.' },
  { I: Leaf, t: 'Rispetto Totale', d: 'Formula spray senza gas, sicura per l\'uomo e per l\'ambiente.' },
];

const APPLICATIONS = [
  { I: Sofa, t: 'Tessuti & Arredi', d: 'Tende, divani, passatoie e tappeti.' },
  { I: Building2, t: 'Ambienti Comuni', d: 'Scale, ascensori, uffici e sale d\'attesa.' },
  { I: Bath, t: 'Aree Tecniche', d: 'Sanitari, WC, scarpiere e cestini.' },
  { I: PawPrint, t: 'Settore Pet', d: 'Ideale per cucce e lettiere (sicuro e delicato).' },
];

const CERTS = [
  'Senza VOC — Priva di sostanze volatili pericolose (Direttive 1999/13/CE e 2004/42/CE).',
  'Senza Fosfati, Fosfonati e Acidi.',
  'Sistema H.A.C.C.P. — Idoneo per l\'utilizzo in ambienti alimentari e sanitari.',
];

export default function ProductDescription({ product }) {
  const aroma = product.fragranceLabel;
  const tipo = product.categoryLabel === 'Bundle' ? 'Kit' : product.categoryLabel === 'Sgrassatori' ? 'Sgrassatore' : product.categoryLabel;

  return (
    <section data-testid="product-description" className="mt-20">
      {/* Intro */}
      <div className="bg-essenya-ink text-white rounded-[2rem] p-8 md:p-14 relative overflow-hidden">
        <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-essenya-champagne/10 blur-3xl" />
        <div className="relative max-w-3xl">
          <div className="text-eyebrow text-white/60 mb-4">Descrizione</div>
          <h2 className="font-display text-3xl md:text-5xl leading-[1.08] font-medium mb-3">
            {tipo} Profumato Professionale <span className="text-essenya-champagne">{aroma}</span>
          </h2>
          <p className="font-display text-xl md:text-2xl text-white/90 mb-6">Più di un profumo, un Neutralizzatore Attivo.</p>
          <p className="text-white/85 text-lg mb-4">Igienizza, Deodora e Rigenera ogni spazio con un solo tocco.</p>
          <p className="text-white/70 leading-relaxed">
            Non limitarti a coprire i cattivi odori: abbattili alla radice. La nostra essenza alla{' '}
            <span className="text-white font-medium">{aroma.toLowerCase()}</span>, a pH neutro, utilizza una tecnologia
            avanzata che disgrega le molecole maleodoranti, garantendo una freschezza persistente e un ambiente salubre.
          </p>
        </div>
      </div>

      {/* Perché è un alleato indispensabile */}
      <div className="mt-10">
        <h3 className="font-display text-2xl md:text-3xl mb-6">Perché è un alleato indispensabile?</h3>
        <div className="grid sm:grid-cols-2 gap-4">
          {FEATURES.map(({ I, t, d }, i) => (
            <div key={i} data-testid={`desc-feature-${i}`} className="bg-white rounded-2xl border border-essenya-border p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-11 h-11 rounded-xl bg-essenya-surface2 flex items-center justify-center mb-4">
                <I size={20} strokeWidth={1.5} />
              </div>
              <p className="font-medium mb-1.5">{t}</p>
              <p className="text-essenya-text text-sm leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Applicazioni */}
      <div className="mt-10">
        <h3 className="font-display text-2xl md:text-3xl mb-6">Applicazioni Professionali e Domestiche</h3>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {APPLICATIONS.map(({ I, t, d }, i) => (
            <div key={i} data-testid={`desc-app-${i}`} className="bg-essenya-surface2 rounded-2xl p-6">
              <I size={22} strokeWidth={1.5} className="mb-3 text-essenya-ink" />
              <p className="font-medium mb-1">{t}</p>
              <p className="text-essenya-text text-sm">{d}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Sicurezza e certificazioni */}
      <div className="mt-10 bg-white rounded-[2rem] border border-essenya-border p-8 md:p-10">
        <div className="flex items-center gap-3 mb-6">
          <ShieldCheck size={24} strokeWidth={1.5} />
          <h3 className="font-display text-2xl md:text-3xl">Sicurezza e Certificazioni</h3>
        </div>
        <p className="text-essenya-text mb-6">Scegliamo la trasparenza. La nostra formula è:</p>
        <ul className="space-y-3">
          {CERTS.map((c, i) => (
            <li key={i} data-testid={`desc-cert-${i}`} className="flex items-start gap-3">
              <span className="mt-0.5 w-6 h-6 rounded-full bg-essenya-ink text-white flex items-center justify-center flex-shrink-0">
                <Check size={14} strokeWidth={2.5} />
              </span>
              <span className="text-essenya-text leading-relaxed">{c}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
